import { GraphQLField } from 'graphql';
import FileField from '@/components/FormBuilder/fields/FileField.vue';
import PreviewMediaField from '@/components/FormBuilder/preview/PreviewFileField.vue';
import FieldComponentFactory from './FieldComponentFactory';

export default class MediaFieldFactory extends FieldComponentFactory {
  readonly component = FileField;

  readonly previewComponent = PreviewMediaField;

  support(field: GraphQLField<any, any, any>): boolean {
    return this.typeInspector.isImageInput(field.type);
  }
}
